<template>
    <div class="loginForm">
      <ValidationObserver tag="div" ref="form">
        <h2>Zaloguj się</h2>
        <div class="row" >
          <div class="col-md-12 col-lg-12">
              <ValidationProvider tag="div" ref="login" class="form-group" :rules="loginRequired" v-slot="{ errors, dirty, valid , classes  }" >
                <div>
                  <label for="loginName" class="required">Login lub e-mail</label>
                  <input
                    class="form-control"
                    :class="classes"
                    type="text"
                    name="loginName"
                    id="loginName"
                    placeholder="Login lub e-mail"
                   v-model="userName">
                </div>

                <ul class="errors">
                  <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
                </ul>

              </ValidationProvider>

              <ValidationProvider tag="div" ref="password" class="form-group" :rules="loginRequired" v-slot="{ errors, dirty, valid , classes  }" >
                <div>
                  <label for="loginPassword" class="required">Hasło</label>
                  <input
                     class="form-control password"
                     :class="classes"
                     :type="passwordVisible ? 'text' : 'password'"
                     name="loginPassword"
                     id="loginPassword"
                     placeholder="Hasło"
                     v-model="userPassword"
                    >
                    <a href="#" class="show-password" role="button" @click.prevent="togglePasswordVisibility">
                      <span class="mi" :class="passwordVisible ? 'mi-eye-open': 'mi-eye-close'"></span>
                    </a>
                </div>
                <ul class="errors">
                  <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
                </ul>
                <ul class="errors" v-if="invalidCredentialsError">
                  <li class="text-danger">Nieprawidłowe dane logowania</li>
                </ul>
              </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="loginForm__forgot"><a class="link" href="/user/forgot">Zapomniałeś hasło do konta? Pomożemy je odzyskać.</a></div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="loginForm__actions">
              <a href="/user/register" class="btn btn-outline-primary">Zarejestruj się</a>
              <button @click.prevent="handleSubmit" class="btn btn-primary">Zaloguj się</button>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { DataLayerManager } from '@/utils/DataLayerManager';
import { RepositoryFactory } from '../../repositories/RepositoryFactory';
import { setShouldResetConfection } from '@/store/sore-helpers';

const shop = RepositoryFactory.get('security');
export default {
  name: 'LoginFormWrapper',
  data() {
    return {
      userName: '',
      userPassword: '',
      isRequired: false,
      invalidCredentialsError: false,
      passwordVisible: false,
    };
  },
  computed: {
    loginRequired() {
      return this.isRequired ? 'required' : '';
    },
    ...mapState({
      stepType: state => state.steps.stepType,
    }),
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    // eslint-disable-next-line consistent-return
    handleSubmit() {
      this.invalidCredentialsError = false;
      this.isRequired = false;

      if (this.userName === '') {
        this.$refs.login.setErrors(['Pole login jest wymagane']);
        return false;
      }
      if (this.userPassword === '') {
        this.$refs.password.setErrors(['Pole hasło jest wymagane']);
        return false;
      }

      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          shop.login(this.userName, this.userPassword).then((response) => {
            if (response.data !== false) {
              this.$store.dispatch('step/setCurrentStep', this.stepType.INVOICE);
              this.$store.dispatch('cart/setUserIsGuest').then(() => {
                DataLayerManager.pushLoginEvent();
                setShouldResetConfection(true);
                window.location.reload(true);
              });
            } else {
              this.invalidCredentialsError = true;
            }
          }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error.message);
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">

  input.valid {
    color: #3c763d;
    border:1px solid #3c763d;
    background-color: #dff0d8;
  }

  input.invalid {
    color: #a94442;
    border:1px solid #a94442;
    background-color: #f2dede;
  }

</style>
